import { H1, H2, Header } from "../../Styles/Global.Styled";
import landingBg from "../../assets/Images/landingBg.jpg";
import { css } from "styled-components";

const bgImg = (img) => css`
  background-image: url(${img || landingBg});
`;
const textAlign = css`
  text-align: center;
`;
const h1Style = (color) => css`
  color: ${color};
  text-align:center;
`;

const PageHeader = ({ header, subHeader, img, color }) => {
  return (
    <Header $baseStyle={bgImg(img)}>
      <H1 $baseStyle={h1Style(color)}>{header}</H1>
      <H2 $baseStyle={textAlign}>{subHeader}</H2>
    </Header>
  );
};

export default PageHeader;
